import { useEffect } from "react";

import { BBox } from "geojson";

import CountryCode from "@mapmycustomers/shared/enum/CountryCode";

import { useMap } from "@app/component/map/FeaturedMap";
import getBoundaryUrl from "@app/scene/map/utils/getBoundaryUrl";

interface CountryMeta {
  focusBbox: BBox;
}

const useFocusBbox = (countryCode: CountryCode): void => {
  const { map } = useMap();

  // this useEffect loads data, it was the first useLookup called for this countryCode
  useEffect(() => {
    fetch(getBoundaryUrl("meta", countryCode))
      .then((response) => response.json())
      .then((countryMeta: CountryMeta) => {
        const [minLon, minLat, maxLon, maxLat] = countryMeta.focusBbox;
        const bounds = new google.maps.LatLngBounds(
          { lat: minLat, lng: minLon },
          { lat: maxLat, lng: maxLon }
        );
        map.fitBounds(bounds);
      });
  }, [countryCode, map]);
};

export default useFocusBbox;
